export class InitializeUserState {
  static type = 'InitializeUserState';
  constructor(public payload: any) {}
}
